import { createAction } from 'redux-actions';

import { idCreator, metaCreator, payloadCreator } from './creator';
import { checkForCachedDataAction, requestAction, secondTimeFormat } from './request';
import fetch, {
  Api,
  getExtendedRequestConfig,
  defaultRequestConfig,
  handleError,
  getJson,
} from './fetch';

export const consentsLoadedAction = createAction('CONSENTS_LOADED', payloadCreator, metaCreator);

export const consentResponseAction = createAction('CONSENT_RESPONSE', payloadCreator, metaCreator);

export const initConsent = ({ organization, practitioner }) => {
  const organizationPart = organization ? `organization=${
    encodeURIComponent(organization)
  }${
    practitioner ? '&' : ''
  }` : '';
  const practitionerPart = practitioner ? `practitioner=${encodeURIComponent(practitioner)}` : '';
  const url = `${Api}/consents?${organizationPart}${practitionerPart}`;
  return fetch(url, getExtendedRequestConfig({ params: { method: 'POST' } }))
    .then(handleError)
    .then(getJson);
};

export const getConsents = () => (dispatch) => {
  const id = idCreator();
  const description = `Fetching consents at ${secondTimeFormat(new Date())}`;
  return checkForCachedDataAction(requestAction({ id, description }), dispatch)
    .then(() => fetch(`${Api}/consents`, defaultRequestConfig))
    .then(handleError)
    .then(getJson)
    .then(json => dispatch(consentsLoadedAction({ id, description, data: json })))
    .catch(error => dispatch(consentsLoadedAction({ id, description, error })));
};

export const requestConsent = ({ organization, practitioner }) => (dispatch) => {
  const id = idCreator();
  const description = `Requesting consent at ${secondTimeFormat(new Date())}`;

  const organizationPart = organization ? `organization=${
    encodeURIComponent(organization)
  }${
    practitioner ? '&' : ''
  }` : '';
  const practitionerPart = practitioner ? `practitioner=${encodeURIComponent(practitioner)}` : '';
  const url = `${Api}/consents?${organizationPart}${practitionerPart}`;
  
  return checkForCachedDataAction(requestAction({ id, description }), dispatch)
    .then(() => fetch(url, getExtendedRequestConfig({ params: { method: 'POST' } })))
    .then(handleError)
    .then(getJson)
    .then(json => dispatch(consentResponseAction({ id, description, data: json })))
    .catch(error => dispatch(consentResponseAction({ id, description, error })));
};

export const giveConsent = ({ consentId, given }) => (dispatch) => {
  const id = idCreator();
  const description = `Responding to consent request ${id} at ${secondTimeFormat(new Date())}`;
  return checkForCachedDataAction(requestAction({ id, description }), dispatch)
    .then(() => fetch(
      `${Api}/consents?id=${consentId}&response=${given ? 'give' : 'deny'}`,
      getExtendedRequestConfig({ params: { method: 'PUT' } })))
    .then(handleError)
    .then(getJson)
    .then(json => dispatch(consentResponseAction({ id, description, data: json })))
    .catch(error => dispatch(consentResponseAction({ id, description, error })));
};

export const deleteConsentRequest = ({ consentId }) => (dispatch) => {
  const id = idCreator();
  const description = `Deleting consent request ${id} at ${secondTimeFormat(new Date())}`;
  return checkForCachedDataAction(requestAction({ id, description }), dispatch)
    .then(() => fetch(`${Api}/consents?id=${consentId}`,
    getExtendedRequestConfig({ params: { method: 'DELETE' } })))
    .then(handleError)
    .then(getJson)
    .then(json => dispatch(consentsLoadedAction({ id, description, data: json })))
    .catch(error => dispatch(consentsLoadedAction({ id, description, error })));
};
